import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {InputAdornment, TextField} from "@mui/material";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import MDTypography from "../MDTypography";
import pxToRem from "../../Asset/theme/functions/pxToRem";
import {useMemo, useState} from "react";
import MDInput from "../MDInput";
import ClearIcon from '@mui/icons-material/Clear';

export default function MDDate({
                                   fullWidth,
                                   defaultValue,
                                   label,
                                   name,
                                   onChange,
                                   disabled,
                                   error,
    w,
                                   helperText,
                                   portal = false,
                               }) {


    let lang = persian_fa;

    let weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

    const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    return (<>
        <DatePicker
            calendar={persian}
            containerStyle={{
                width: "100%",
            }}
            locale={lang}
            digits={digits}
            // portal={portal}
            className="custom-calendar"

            weekDays={weekDays}

            format="YYYY-MM-DD"
            onChange={(e) => {
                return onChange(e.format("YYYY-MM-DD", ["Date", "Time"]));
            }}
            value={defaultValue}
            render={(value, openCalendar) => {
                return (<MDInput
                    value={value}

                    sx={{width: fullWidth ? "100%" :  w}}

                    name={name}
                    onClick={openCalendar}
                    id="input-with-icon-textfield"
                    label={label}
                    autoComplete={"off"}
                    InputProps={{
                        startAdornment: (<InputAdornment position="start">
                            <CalendarMonthIcon/>
                        </InputAdornment>),
                        endAdornment: (
                            <InputAdornment sx={{m: "-17px", p: "17px"}} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation()
                                return onChange("");

                            }} position="start">
                                <ClearIcon/>
                            </InputAdornment>),
                    }}
                />);
            }}
        />
        {error && (<MDTypography
            color={"error"}
            fontSize={pxToRem(12)}
            sx={{margin: "0 12px"}}
        >
            {helperText}
        </MDTypography>)}
    </>);
}
